<ng-container *ngIf="(media === 'xs' || media === 'sm') else deskmode">
    <div class="calcontainermobile">
        <div class="calwrapperMobile">
            <div class="acwrapper">
                <button mat-icon-button (click)="previus()">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button mat-icon-button (click)="next()">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
            <div class="calcontainer width100">
                <div class="width100">
                    <div class="month_header">
                        <span multilang>{{first_header}}</span>
                    </div>
                    <ng-container *ngTemplateOutlet="mymonth; context:{month:first_month}"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #deskmode>
    <div class="calwrapper mat-elevation-z2">
        <div class="acwrapper">
            <button mat-icon-button (click)="previus()">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button mat-icon-button (click)="next()">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
        <div class="calcontainer">
            <div>
                <div class="month_header">
                    <span multilang>{{first_header}}</span>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:first_month}"></ng-container>
            </div>
            <div style="margin-left: 1.5rem;">
                <div class="month_header">
                    <span multilang>{{second_header}}</span>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:second_month}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #day let-md="md">
    <div (click)="selectDay(md)" [ngClass]="md?.class" title="{{md?.tooltip}}" (mouseleave)="selectTmp_Day(null)"
        (mouseenter)="selectTmp_Day(md)" class="daywr"
        [class.selectedday]="md?.id?.length > 0 && ((start?.length > 0 && md.id === start) || (end?.length > 0 && md.id === end))"
        [class.included]="md?.id > start && (md?.id < tmp_end?.id || md?.id < end)"
        [class.disabledday]="!md || md?.id < today">
        <span multilang class="dday">{{md?.value}}</span>
    </div>
</ng-template>

<ng-template #mymonth let-month="month">
    <div class="caltab">
        <div>
            <div class="case mheader">
                <span multilang class="mdaym" *ngFor="let hd of header_week">{{hd}}</span>
            </div>
        </div>
        <div>
            <div class="case">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_0}"></ng-container>
            </div>
            <div class="case">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_1}"></ng-container>
            </div>
            <div class="case">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_2}"></ng-container>
            </div>
            <div class="case">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_3}"></ng-container>
            </div>
            <div class="case">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_4}"></ng-container>
            </div>
            <div class="case">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_5}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cells let-arr="arr">
    <div class="mday" [class.mdayMobile]="media === 'xs' || media === 'sm'" *ngFor="let md of arr">
        <ng-container *ngTemplateOutlet="day; context:{md:md}"></ng-container>
    </div>
</ng-template>